import api from "./api";

export interface Cobertura {
    id: number;
    nome: string;
}

export interface CoberturaInput {
    nome: string;
}

const getAuthHeaders = () => {
    const token = localStorage.getItem('authToken');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getCoberturas = async (): Promise<Cobertura[]> => {
    try {
        const response = await api.get('/coberturas', getAuthHeaders());
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar coberturas:", error);
        throw error;
    }
};

export const createCobertura = async (data: CoberturaInput): Promise<Cobertura> => {
    const response = await api.post('/coberturas', data, getAuthHeaders());
    return response.data;
};

export const updateCobertura = async (id: number, data: CoberturaInput): Promise<Cobertura> => {
    const response = await api.put(`/coberturas/${id}`, data, getAuthHeaders());
    return response.data;
};

export const deleteCobertura = async (id: number): Promise<void> => {
    await api.delete(`/coberturas/${id}`, getAuthHeaders());
};